import { render } from "./judicial.vue?vue&type=template&id=7eab520e"
import script from "./judicial.vue?vue&type=script&lang=js"
export * from "./judicial.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__